import React from 'react';

const RatingScale = ({ value, onChange }) => {
  const ratings = [
    { value: 0, label: 'Not familiar', color: 'bg-gray-400' },
    { value: 1, label: 'Aware but inexperienced', color: 'bg-red-400' },
    { value: 2, label: 'Novice / learning with supervision', color: 'bg-orange-400' },
    { value: 3, label: 'Entry-to-practice / practices with some support', color: 'bg-yellow-400' },
    { value: 4, label: 'Independent / skilled', color: 'bg-green-400' },
    { value: 5, label: 'Advanced / can teach or supervise', color: 'bg-blue-500' }
  ];

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {ratings.map((rating) => (
          <button
            key={rating.value}
            type="button"
            onClick={() => onChange(rating.value)}
            className={`
              px-4 py-2 rounded-lg border-2 transition-all duration-200 text-sm font-medium
              ${value === rating.value 
                ? `${rating.color} border-gray-800 text-white shadow-lg scale-105` 
                : 'bg-white border-gray-300 text-gray-700 hover:border-gray-400'
              }
            `}
          >
            {rating.value}
          </button>
        ))}
      </div>
      
      {value !== null && value !== undefined && (
        <div className="text-sm text-gray-600 italic">
          {ratings[value]?.label}
        </div>
      )}
    </div>
  );
};

export default RatingScale;